module.exports = __webpack_public_path__ + "static/img/fqi.6084bdc8.svg";